/* global angular */

angular.module('gc.perfs', []).service('Perfs', [
  function() {
  'use strict';

    var measurements = {};

    return {

      init: function() {
        measurements['start'] = new Date().getTime();
      },

      measure: function(name) {
        measurements[name] = new Date().getTime();
      },

      done: function() {
        measurements['render'] = new Date().getTime();

        var start = measurements['start'];
        var end = measurements['render'];
        var output = ['debug perfs:'];
        var prev = 0;

        for (var name in measurements) {
          if (name === 'start') continue
          var duration = measurements[name] - start - prev;
          var percent = Math.round(duration / (end - start) * 100);
          output.push('- ' + name + ': ' + duration + 'ms (' + percent + '%)');
          prev = measurements[name] - start;
        }

        window.debugPerfs = function() {
          console.debug(output.join('\r\n'));
        };
      },

    }

  }]);


